import {type UseQueryResult, useQuery} from '@tanstack/react-query';

import type {PeopleDirectory} from '../types';
import {getRequest} from '../utils/httpClient';

/** Hook for `GET /api/admin/people`: the company directory, or `available: false` when it cannot be read. */
export const usePeople = (): UseQueryResult<PeopleDirectory> =>
    useQuery({
        queryKey: ['people'],
        queryFn: () => getRequest<PeopleDirectory>('/api/admin/people'),
        staleTime: 5 * 60 * 1000,
    });

/** Where a person's photo is served from. */
export const photoUrl = (personId: string): string => `/api/admin/people/${personId}/photo`;
